class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    // DISABLED: AJAX submit - biarkan form submit normal untuk reload halaman
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('submit', (e) => e.preventDefault());

    // ENABLE: Submit form secara normal (reload halaman) ketika checkbox berubah
    // const facetForm = this.querySelector('form');
    // if (facetForm) {
    //   // Submit form ketika checkbox/input berubah (tanpa preventDefault)
    //   facetForm.addEventListener('change', (event) => {
    //     // Biarkan form submit secara default untuk reload halaman
    //     facetForm.submit();
    //   });
    // }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
      // Update breadcrumb dan title setelah history change
      setTimeout(() => {
        FacetFiltersForm.updateBreadcrumbFromActiveFilters();
        FacetFiltersForm.updateTitleFromActiveFilters();
      }, 100);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  /** Navigasi filter via AJAX (tanpa full page reload). Dipakai tombol hapus filter, clear all, Show All, dll. */
  static applyFilterFromLink(event) {
    if (event?.preventDefault) event.preventDefault();
    const anchor = event?.currentTarget;
    if (!anchor || !anchor.getAttribute) return;
    const href = anchor.getAttribute('href') || '';
    if (!href || href === '#') return;

    FacetFiltersForm.toggleActiveFacets(true);

    let searchParams = '';
    try {
      const u = new URL(href, window.location.origin);
      searchParams = u.search ? u.search.slice(1) : '';
    } catch (e) {
      const q = href.indexOf('?');
      searchParams = q === -1 ? '' : href.slice(q + 1);
    }

    FacetFiltersForm.renderPage(searchParams, event);
  }

  /** Hapus state loading di grid/facet jika fetch/update gagal (hindari overlay abadi). */
  static endLoading() {
    document.querySelector('#ProductGridContainer .collection')?.classList.remove('loading');
    document.getElementById('ProductCount')?.classList.remove('loading');
    document.getElementById('ProductCountDesktop')?.classList.remove('loading');
    document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    ).forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const gridWrap = document.getElementById('ProductGridContainer');
    gridWrap?.querySelector('.collection')?.classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    if (!sections.length) {
      console.error('FacetFiltersForm: #product-grid[data-id] missing; cannot load section.');
      FacetFiltersForm.endLoading();
      return;
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Section fetch ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        // Grid & count dulu: jika renderFilters error, produk tetap ter-update (hindari overlay loading nyangkut).
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        try {
          FacetFiltersForm.renderFilters(html, event);
        } catch (err) {
          console.error('FacetFiltersForm.renderFilters failed', err);
        }
        // Update breadcrumb dan title setelah semua render selesai
        setTimeout(() => {
          FacetFiltersForm.updateBreadcrumbFromActiveFilters();
          FacetFiltersForm.updateTitleFromActiveFilters();
        }, 100);
        const gridEl = document.getElementById('ProductGridContainer');
        if (typeof initializeScrollAnimationTrigger === 'function' && gridEl) {
          initializeScrollAnimationTrigger(gridEl);
        }
        document.dispatchEvent(new CustomEvent('facetFiltersForm:updated'));
      })
      .catch((err) => {
        console.error('Facet section fetch failed', err);
        FacetFiltersForm.endLoading();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    try {
      FacetFiltersForm.renderFilters(html, event);
    } catch (err) {
      console.error('FacetFiltersForm.renderFilters failed', err);
    }
    // Update breadcrumb dan title setelah semua render selesai
    setTimeout(() => {
      FacetFiltersForm.updateBreadcrumbFromActiveFilters();
      FacetFiltersForm.updateTitleFromActiveFilters();
    }, 100);
    const gridEl = document.getElementById('ProductGridContainer');
    if (typeof initializeScrollAnimationTrigger === 'function' && gridEl) {
      initializeScrollAnimationTrigger(gridEl);
    }
    document.dispatchEvent(new CustomEvent('facetFiltersForm:updated'));
  }

  static renderProductGridContainer(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    let source = parsed.getElementById('ProductGridContainer');
    if (!source) {
      source = parsed.querySelector('.product-grid-container');
    }
    const target = document.getElementById('ProductGridContainer');
    if (!source || !target) {
      console.error('FacetFiltersForm: ProductGridContainer not found in section response or DOM.');
      FacetFiltersForm.endLoading();
      return;
    }

    target.innerHTML = source.innerHTML;

    target.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fromCount = parsed.getElementById('ProductCount');
    const fromDesktop = parsed.getElementById('ProductCountDesktop');
    const countHtml = fromCount ? fromCount.innerHTML : fromDesktop ? fromDesktop.innerHTML : null;

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (countHtml != null) {
      if (container) {
        container.innerHTML = countHtml;
        container.classList.remove('loading');
      }
      if (containerDesktop) {
        containerDesktop.innerHTML = countHtml;
        containerDesktop.classList.remove('loading');
      }
    } else {
      container?.classList.remove('loading');
      containerDesktop?.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event?.target?.closest?.('.js-filter');
      return jsFilter ? element.id === jsFilter.id : false;
    };

    // Dawn: saat mengetik di input teks dalam facet, jangan ganti seluruh blok facet itu (biar fokus/counts saja).
    // Untuk klik link/checkbox (mis. Categories), HARUS render ulang facet itu dari server supaya .active / aria-pressed benar.
    const typingInFacet =
      event?.target?.closest?.('.js-filter') &&
      (event.target.type === 'text' || event.target.type === 'search');

    const facetsToRender = typingInFacet
      ? Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element))
      : Array.from(facetDetailsElementsFromFetch);

    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement?.id) {
          const anchor = document
            .getElementById(elementToRender.parentElement.id)
            ?.querySelector('.js-filter');
          if (anchor) anchor.before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.updateBreadcrumbAndTitle(parsedHTML);

    // Partial update counts + focus hanya jika facet yang dipakai tidak diganti utuh (mode ketik di input teks).
    if (typingInFacet && countsToRender && event?.target) {
      const jsFilterRoot = event.target.closest('.js-filter');
      if (jsFilterRoot?.id) {
        const closestJSFilterID = jsFilterRoot.id;
        FacetFiltersForm.renderCounts(countsToRender, jsFilterRoot);
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        if (newFacetDetailsElement) {
          const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

          const isTextInput = event.target.getAttribute('type') === 'text';

          if (newElementToActivate && !isTextInput) newElementToActivate.focus();
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const target = document.querySelector(selector);
      if (!target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const from = html.querySelector(selector);
      if (!from) return;
      const to = document.querySelector(selector);
      if (!to) return;
      to.innerHTML = from.innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const menuDrawer = mobileForm ? mobileForm.closest('menu-drawer') : null;
    if (menuDrawer && typeof menuDrawer.bindEvents === 'function') menuDrawer.bindEvents();
  }

  static updateBreadcrumbAndTitle(html) {
    // Ambil breadcrumb dan title dari HTML baru jika ada
    const newBreadcrumb = html.querySelector('.collection-hero__breadcrumb');
    const newTitle = html.querySelector('#collection-title');
    
    // Update breadcrumb jika ada
    if (newBreadcrumb) {
      const currentBreadcrumb = document.querySelector('.collection-hero__breadcrumb');
      if (currentBreadcrumb) {
        currentBreadcrumb.innerHTML = newBreadcrumb.innerHTML;
      }
    } else {
      // Jika tidak ada di HTML baru, update dari active filters di DOM
      FacetFiltersForm.updateBreadcrumbFromActiveFilters();
    }
    
    // Update title jika ada
    if (newTitle) {
      const currentTitle = document.getElementById('collection-title');
      if (currentTitle) {
        currentTitle.innerHTML = newTitle.innerHTML;
      }
    } else {
      // Jika tidak ada di HTML baru, update dari active filters di DOM
      FacetFiltersForm.updateTitleFromActiveFilters();
    }
  }

  // updateBreadcrumbFromActiveFilters & updateTitleFromActiveFilters: custom logic dipindah ke app-js-2026.js

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const grid = document.getElementById('product-grid');
    const id = grid?.dataset?.id;
    if (!id) return [];
    return [{ section: id }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
    
    // Biarkan form submit secara default (reload halaman)
    // return true;
  }

  onActiveFilterClick(event) {
    FacetFiltersForm.applyFilterFromLink(event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

function interceptFacetNavLink(e, selector) {
  const a = e.target.closest(selector);
  if (!a || e.defaultPrevented) return false;
  const href = a.getAttribute('href');
  if (!href || href === '#') return false;
  e.preventDefault();
  FacetFiltersForm.applyFilterFromLink({ currentTarget: a, target: e.target, preventDefault: function () {} });
  return true;
}

// Link filter collection: Show All, reset facet, clear mobile — AJAX tanpa reload
document.addEventListener(
  'click',
  function (e) {
    if (interceptFacetNavLink(e, 'a.facets__show-all-button[href]')) return;
    if (interceptFacetNavLink(e, 'a.facets__reset[href]')) return;
    if (interceptFacetNavLink(e, 'a.mobile-facets__clear[href]')) return;
  },
  true
);

// Fallback sinkronisasi state active dari URL.
// Dipakai jika response facet tidak mem-markup class active secara konsisten.
function syncSingleSelectFacetStateFromUrl() {
  const params = new URLSearchParams(window.location.search || '');
  const normalizeValue = (v) => decodeURIComponent(String(v || '')).toLowerCase();
  const applyPressedState = (link, pressed) => {
    if (!link) return;
    link.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    const isActiveByAria = link.getAttribute('aria-pressed') === 'true';
    link.classList.toggle('active', isActiveByAria);
    if (link.classList.contains('mobile-facets__category-pill')) {
      link.classList.toggle('mobile-facets__category-pill--active', isActiveByAria);
    }

    const parentItem = link.closest('.facets__item, .mobile-facets__item-horizontal');
    if (parentItem) parentItem.classList.toggle('facets__item--active', isActiveByAria);
  };

  document.querySelectorAll('a[data-single-select][data-filter-param][data-value]').forEach((link) => {
    const filterParam = link.getAttribute('data-filter-param') || '';
    const valueParam = link.getAttribute('data-value-param') || '';
    const value = normalizeValue(link.getAttribute('data-value') || '');
    const selectedByFilter = params.getAll(filterParam).map((v) => normalizeValue(v));
    const selectedByValueParam = valueParam ? params.getAll(valueParam).map((v) => normalizeValue(v)) : [];
    const isActive = selectedByFilter.includes(value) || selectedByValueParam.includes(value);

    applyPressedState(link, isActive);
  });

  document.querySelectorAll('.facets__side-by-side-options').forEach((groupEl) => {
    const showAll = groupEl.querySelector('a.facets__show-all-button');
    if (!showAll) return;
    const hasActive = Array.from(groupEl.querySelectorAll('a[data-single-select][aria-pressed="true"]')).length > 0;
    showAll.classList.toggle('active', !hasActive);
  });

  document.querySelectorAll('.mobile-facets__group-options').forEach((groupEl) => {
    const showAll = groupEl.querySelector('a.mobile-facets__option-link');
    if (!showAll) return;
    const showAllText = (showAll.textContent || '').trim().toLowerCase();
    if (showAllText !== 'show all') return;
    const hasActive =
      Array.from(
        groupEl.querySelectorAll('a[data-single-select][aria-pressed="true"], a.mobile-facets__option-link.active')
      ).filter((link) => link !== showAll).length > 0;
    showAll.classList.toggle('active', !hasActive);
  });
}

document.addEventListener('DOMContentLoaded', syncSingleSelectFacetStateFromUrl);
document.addEventListener('facetFiltersForm:updated', syncSingleSelectFacetStateFromUrl);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    const form = this.closest('facet-filters-form');
    if (form && typeof form.onActiveFilterClick === 'function') {
      form.onActiveFilterClick(event);
    } else {
      FacetFiltersForm.applyFilterFromLink(event);
    }
  }
}

customElements.define('facet-remove', FacetRemove);
